import { FunctionComponent } from 'react';

export const DiscordWidget: FunctionComponent = () => {
  return (
    <iframe
      src={'https://discord.com/widget?id=920013738545909920&theme=dark'}
      width="400"
      height="500"
      frameBorder={0}
      sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
    ></iframe>
  );
};
